import { createContext, useState, useContext, useCallback, useRef } from 'react'

const ServiceWorkerContext = createContext()

export const ServiceWorkerProvider = ({ children }) => {
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false)
  const updateAssetsRef = useRef(null)

  const setUpdateAssets = useCallback((fn) => {
    updateAssetsRef.current = fn
  }, [])

  const updateAssets = useCallback(() => {
    if (updateAssetsRef.current) {
      updateAssetsRef.current()
    } else if (isUpdateAvailable) {
      window.location.reload()
    }
  }, [isUpdateAvailable])

  return (
    <ServiceWorkerContext.Provider value={{ isUpdateAvailable, setIsUpdateAvailable, updateAssets, setUpdateAssets }}>
      {children}
    </ServiceWorkerContext.Provider>
  )
}

export const useServiceWorker = () => useContext(ServiceWorkerContext)
